(function() {
    'use strict';
    angular
        .module('tmgApp')
        .factory('FleetDailyTrip', FleetDailyTrip);

    FleetDailyTrip.$inject = ['$resource', 'DateUtils'];

    function FleetDailyTrip ($resource, DateUtils) {
        var resourceUrl =  'api/fleet-daily-trips/:id';

        return $resource(resourceUrl, {id: '@id'}, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                        data.timeStart = DateUtils.convertDateTimeFromServer(data.timeStart);
                        data.timeEnd = DateUtils.convertDateTimeFromServer(data.timeEnd);
                    }
                    return data;
                }
            },
            'update': {
                url: 'api/fleet-daily-trips',
                method: 'PUT'
            },
            'importFile': {
                url: 'api/fleet-daily-trips/import',
                method: 'POST'
            }
        });
    }
})();
